// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".css?ver=2d7661e8-1999-428c-8b4a-fa97b38bf732";
};